import React from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';

interface ShowMoreTextProps {
  text: string;
  maxChars?: number;
  expanded: boolean;
  onToggle: () => void;
  showMoreLabel?: string;
  showLessLabel?: string;
  textStyle?: any;
  linkStyle?: any;
  rightIcon?: React.ReactNode;
}

export const ShowMoreText: React.FC<ShowMoreTextProps> = ({
  text,
  maxChars = 150,
  expanded,
  onToggle,
  showMoreLabel = 'Show more',
  showLessLabel = 'Show less',
  textStyle,
  linkStyle,
  rightIcon,
}) => {
  const shouldTruncate = text.length > maxChars;
  const displayText = shouldTruncate && !expanded ? `${text.slice(0, maxChars)}...` : text;

  return (
    <View>
      {!!displayText && <Text style={textStyle}>{displayText}</Text>}
      {shouldTruncate && (
        <TouchableOpacity accessibilityRole="button" onPress={onToggle} style={styles.toggleRow}>
          <Text style={linkStyle}>{expanded ? showLessLabel : showMoreLabel}</Text>
          {!!rightIcon && <View style={styles.iconContainer}>{rightIcon}</View>}
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  toggleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 4,
  },
  iconContainer: {
    marginLeft: 4,
  },
});

export default ShowMoreText;


